import apiClient from "../config/api";

const masterDataService = {
  // ========== Departments ==========
  getDepartments: async (tenantId) => {
    const response = await apiClient.get("/masterdata/departments", {
      params: { tenantId },
    });
    return response.data;
  },

  getDepartment: async (id) => {
    const response = await apiClient.get(`/masterdata/departments/${id}`);
    return response.data;
  },

  createDepartment: async (departmentData) => {
    const response = await apiClient.post(
      "/masterdata/departments",
      departmentData,
    );
    return response.data;
  },

  updateDepartment: async (id, departmentData) => {
    const response = await apiClient.post(
      `/masterdata/update/departments/${id}`,
      departmentData,
    );
    return response.data;
  },

  deleteDepartment: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/departments/${id}`);
    return response.data;
  },

  // ========== Shifts ==========
  getShifts: async (tenantId) => {
    const response = await apiClient.get("/masterdata/shifts", {
      params: { tenantId },
    });
    return response.data;
  },

  getShift: async (id) => {
    const response = await apiClient.get(`/masterdata/shifts/${id}`);
    return response.data;
  },

  createShift: async (shiftData) => {
    const response = await apiClient.post("/masterdata/shifts", shiftData);
    return response.data;
  },

  updateShift: async (id, shiftData) => {
    const response = await apiClient.post(`/masterdata/update/shifts/${id}`, shiftData);
    return response.data;
  },

  deleteShift: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/shifts/${id}`);
    return response.data;
  },

  // ========== Loss Types ==========
  getLossTypes: async (tenantId) => {
    const response = await apiClient.get("/masterdata/loss-types", {
      params: { tenantId },
    });
    return response.data;
  },

  getLossType: async (id) => {
    const response = await apiClient.get(`/masterdata/loss-types/${id}`);
    return response.data;
  },

  createLossType: async (lossTypeData) => {
    const response = await apiClient.post(
      "/masterdata/loss-types",
      lossTypeData,
    );
    return response.data;
  },

  updateLossType: async (id, lossTypeData) => {
    const response = await apiClient.post(
      `/masterdata/update/loss-types/${id}`,
      lossTypeData,
    );
    return response.data;
  },

  deleteLossType: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/loss-types/${id}`);
    return response.data;
  },

  // ========== Roles ==========
  getRoles: async (tenantId) => {
    const response = await apiClient.get("/masterdata/roles", {
      params: { tenantId },
    });
    return response.data;
  },

  getRole: async (id) => {
    const response = await apiClient.get(`/masterdata/roles/${id}`);
    return response.data;
  },

  createRole: async (roleData) => {
    const response = await apiClient.post("/masterdata/roles", roleData);
    return response.data;
  },

  updateRole: async (id, roleData) => {
    const response = await apiClient.post(`/masterdata/update/roles/${id}`, roleData);
    return response.data;
  },

  deleteRole: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/roles/${id}`);
    return response.data;
  },

  // ========== Categories ==========
  getCategories: async (tenantId) => {
    const response = await apiClient.get("/masterdata/categories", {
      params: { tenantId },
    });
    return response.data;
  },

  getCategory: async (id) => {
    const response = await apiClient.get(`/masterdata/categories/${id}`);
    return response.data;
  },

  createCategory: async (categoryData) => {
    const response = await apiClient.post(
      "/masterdata/categories",
      categoryData,
    );
    return response.data;
  },

  updateCategory: async (id, categoryData) => {
    const response = await apiClient.post(
      `/masterdata/update/categories/${id}`,
      categoryData,
    );
    return response.data;
  },

  deleteCategory: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/categories/${id}`);
    return response.data;
  },

  // ========== Statuses ==========
  getStatus: async (id) => {
    const response = await apiClient.get(`/masterdata/statuses/${id}`);
    return response.data;
  },

  createStatus: async (statusData) => {
    const response = await apiClient.post("/masterdata/statuses", statusData);
    return response.data;
  },

  updateStatus: async (id, statusData) => {
    const response = await apiClient.post(
      `/masterdata/update/statuses/${id}`,
      statusData,
    );
    return response.data;
  },

  deleteStatus: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/statuses/${id}`);
    return response.data;
  },

  // ========== Impact Levels ==========
  getImpactLevels: async (tenantId) => {
    const response = await apiClient.get("/masterdata/impact-levels", {
      params: { tenantId },
    });
    return response.data;
  },

  getImpactLevel: async (id) => {
    const response = await apiClient.get(`/masterdata/impact-levels/${id}`);
    return response.data;
  },

  createImpactLevel: async (impactLevelData) => {
    const response = await apiClient.post(
      "/masterdata/impact-levels",
      impactLevelData,
    );
    return response.data;
  },

  updateImpactLevel: async (id, impactLevelData) => {
    const response = await apiClient.post(
      `/masterdata/update/impact-levels/${id}`,
      impactLevelData,
    );
    return response.data;
  },

  deleteImpactLevel: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/impact-levels/${id}`);
    return response.data;
  },

  // ========== Triggers ==========
  getTriggers: async (tenantId) => {
    const response = await apiClient.get("/masterdata/triggers", {
      params: { tenantId },
    });
    return response.data;
  },

  getTrigger: async (id) => {
    const response = await apiClient.get(`/masterdata/triggers/${id}`);
    return response.data;
  },

  createTrigger: async (triggerData) => {
    const response = await apiClient.post("/masterdata/triggers", triggerData);
    return response.data;
  },

  updateTrigger: async (id, triggerData) => {
    const response = await apiClient.post(
      `/masterdata/update/triggers/${id}`,
      triggerData,
    );
    return response.data;
  },

  deleteTrigger: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/triggers/${id}`);
    return response.data;
  },

  // ========== Loss Sub Types ==========
  getLossSubTypes: async (tenantId, lossTypeId = null) => {
    const params = { tenantId };
    if (lossTypeId) params.lossTypeId = lossTypeId;
    const response = await apiClient.get("/masterdata/loss-sub-types", {
      params,
    });
    return response.data;
  },

  getLossSubType: async (id) => {
    const response = await apiClient.get(`/masterdata/loss-sub-types/${id}`);
    return response.data;
  },

  createLossSubType: async (lossSubTypeData) => {
    const response = await apiClient.post(
      "/masterdata/loss-sub-types",
      lossSubTypeData,
    );
    return response.data;
  },

  updateLossSubType: async (id, lossSubTypeData) => {
    const response = await apiClient.post(
      `/masterdata/update/loss-sub-types/${id}`,
      lossSubTypeData,
    );
    return response.data;
  },

  deleteLossSubType: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/loss-sub-types/${id}`);
    return response.data;
  },

  // ========== Loss Reasons ==========
  getLossReasons: async (tenantId, lossTypeId = null, lossSubTypeId = null) => {
    const params = { tenantId };
    if (lossTypeId) params.lossTypeId = lossTypeId;
    if (lossSubTypeId) params.lossSubTypeId = lossSubTypeId;
    const response = await apiClient.get("/masterdata/loss-reasons", {
      params,
    });
    return response.data;
  },

  getLossReason: async (id) => {
    const response = await apiClient.get(`/masterdata/loss-reasons/${id}`);
    return response.data;
  },

  createLossReason: async (lossReasonData) => {
    const response = await apiClient.post(
      "/masterdata/loss-reasons",
      lossReasonData,
    );
    return response.data;
  },

  updateLossReason: async (id, lossReasonData) => {
    const response = await apiClient.post(
      `/masterdata/update/loss-reasons/${id}`,
      lossReasonData,
    );
    return response.data;
  },

  deleteLossReason: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/loss-reasons/${id}`);
    return response.data;
  },

  // ========== Cycle Times ==========
  getCycleTimes: async (tenantId, machineId = null, productId = null) => {
    const params = { tenantId };
    if (machineId) params.machineId = machineId;
    if (productId) params.productId = productId;
    const response = await apiClient.get("/masterdata/cycle-times", { params });
    return response.data;
  },

  getCycleTime: async (id) => {
    const response = await apiClient.get(`/masterdata/cycle-times/${id}`);
    return response.data;
  },

  createCycleTime: async (cycleTimeData) => {
    const response = await apiClient.post(
      "/masterdata/cycle-times",
      cycleTimeData,
    );
    return response.data;
  },

  updateCycleTime: async (id, cycleTimeData) => {
    const response = await apiClient.post(
      `/masterdata/update/cycle-times/${id}`,
      cycleTimeData,
    );
    return response.data;
  },

  deleteCycleTime: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/cycle-times/${id}`);
    return response.data;
  },

  // ========== Planned Downtimes ==========
  getPlannedDowntimes: async (tenantId) => {
    const response = await apiClient.get("/masterdata/planned-downtimes", {
      params: { tenantId },
    });
    return response.data;
  },

  getPlannedDowntime: async (id) => {
    const response = await apiClient.get(`/masterdata/planned-downtimes/${id}`);
    return response.data;
  },

  createPlannedDowntime: async (plannedDowntimeData) => {
    const response = await apiClient.post(
      "/masterdata/planned-downtimes",
      plannedDowntimeData,
    );
    return response.data;
  },

  updatePlannedDowntime: async (id, plannedDowntimeData) => {
    const response = await apiClient.post(
      `/masterdata/update/planned-downtimes/${id}`,
      plannedDowntimeData,
    );
    return response.data;
  },

  deletePlannedDowntime: async (id) => {
    const response = await apiClient.post(
      `/masterdata/delete/planned-downtimes/${id}`,
    );
    return response.data;
  },

  // ========== OEE Thresholds ==========
  getOeeThresholds: async (tenantId) => {
    const response = await apiClient.get("/masterdata/oee-thresholds", {
      params: { tenantId },
    });
    return response.data;
  },

  getOeeThreshold: async (id) => {
    const response = await apiClient.get(`/masterdata/oee-thresholds/${id}`);
    return response.data;
  },

  createOeeThreshold: async (oeeThresholdData) => {
    const response = await apiClient.post(
      "/masterdata/oee-thresholds",
      oeeThresholdData,
    );
    return response.data;
  },

  updateOeeThreshold: async (id, oeeThresholdData) => {
    const response = await apiClient.post(
      `/masterdata/update/oee-thresholds/${id}`,
      oeeThresholdData,
    );
    return response.data;
  },

  deleteOeeThreshold: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/oee-thresholds/${id}`);
    return response.data;
  },

  // ========== Attachment Types ==========
  getAttachmentTypes: async (tenantId) => {
    const response = await apiClient.get("/masterdata/attachment-types", {
      params: { tenantId },
    });
    return response.data;
  },

  getAttachmentType: async (id) => {
    const response = await apiClient.get(`/masterdata/attachment-types/${id}`);
    return response.data;
  },

  createAttachmentType: async (attachmentTypeData) => {
    const response = await apiClient.post(
      "/masterdata/attachment-types",
      attachmentTypeData,
    );
    return response.data;
  },

  updateAttachmentType: async (id, attachmentTypeData) => {
    const response = await apiClient.post(
      `/masterdata/update/attachment-types/${id}`,
      attachmentTypeData,
    );
    return response.data;
  },

  deleteAttachmentType: async (id) => {
    const response = await apiClient.post(
      `/masterdata/delete/attachment-types/${id}`,
    );
    return response.data;
  },

  // ========== Work Types ==========
  getWorkTypes: async (tenantId) => {
    const response = await apiClient.get("/masterdata/work-types", {
      params: { tenantId },
    });
    return response.data;
  },

  getWorkType: async (id) => {
    const response = await apiClient.get(`/masterdata/work-types/${id}`);
    return response.data;
  },

  createWorkType: async (workTypeData) => {
    const response = await apiClient.post(
      "/masterdata/work-types",
      workTypeData,
    );
    return response.data;
  },

  updateWorkType: async (id, workTypeData) => {
    const response = await apiClient.post(
      `/masterdata/update/work-types/${id}`,
      workTypeData,
    );
    return response.data;
  },

  deleteWorkType: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/work-types/${id}`);
    return response.data;
  },

  // ========== Root Cause Categories ==========
  getRootCauseCategories: async (tenantId) => {
    const response = await apiClient.get("/masterdata/root-cause-categories", {
      params: { tenantId },
    });
    return response.data;
  },

  getRootCauseCategory: async (id) => {
    const response = await apiClient.get(
      `/masterdata/root-cause-categories/${id}`,
    );
    return response.data;
  },

  createRootCauseCategory: async (categoryData) => {
    const response = await apiClient.post(
      "/masterdata/root-cause-categories",
      categoryData,
    );
    return response.data;
  },

  updateRootCauseCategory: async (id, categoryData) => {
    const response = await apiClient.post(
      `/masterdata/update/root-cause-categories/${id}`,
      categoryData,
    );
    return response.data;
  },

  deleteRootCauseCategory: async (id) => {
    const response = await apiClient.post(
      `/masterdata/delete/root-cause-categories/${id}`,
    );
    return response.data;
  },

  // ========== Failure Modes ==========
  getFailureModes: async (tenantId) => {
    const response = await apiClient.get("/masterdata/failure-modes", {
      params: { tenantId },
    });
    return response.data;
  },

  getFailureMode: async (id) => {
    const response = await apiClient.get(`/masterdata/failure-modes/${id}`);
    return response.data;
  },

  createFailureMode: async (failureModeData) => {
    const response = await apiClient.post(
      "/masterdata/failure-modes",
      failureModeData,
    );
    return response.data;
  },

  updateFailureMode: async (id, failureModeData) => {
    const response = await apiClient.post(
      `/masterdata/update/failure-modes/${id}`,
      failureModeData,
    );
    return response.data;
  },

  deleteFailureMode: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/failure-modes/${id}`);
    return response.data;
  },

  // ========== PPE List ==========
  getPPEList: async (tenantId) => {
    const response = await apiClient.get("/masterdata/ppe-list", {
      params: { tenantId },
    });
    return response.data;
  },

  getPPE: async (id) => {
    const response = await apiClient.get(`/masterdata/ppe-list/${id}`);
    return response.data;
  },

  createPPE: async (ppeData) => {
    const response = await apiClient.post("/masterdata/ppe-list", ppeData);
    return response.data;
  },

  updatePPE: async (id, ppeData) => {
    const response = await apiClient.post(`/masterdata/update/ppe-list/${id}`, ppeData);
    return response.data;
  },

  deletePPE: async (id) => {
    const response = await apiClient.post(`/masterdata/delete/ppe-list/${id}`);
    return response.data;
  },

  // ========== PM Masters ==========
  getMaintenancePlans: async (tenantId, isActive) => {
    const response = await apiClient.get("/pm-masterdata/maintenance-plans", {
      params: { tenantId, isActive },
    });
    return response.data;
  },

  getMaintenancePlan: async (id) => {
    const response = await apiClient.get(
      `/pm-masterdata/maintenance-plans/${id}`,
    );
    return response.data;
  },

  createMaintenancePlan: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/maintenance-plans",
      data,
    );
    return response.data;
  },

  updateMaintenancePlan: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/maintenance-plans/${id}`,
      data,
    );
    return response.data;
  },

  deleteMaintenancePlan: async (id) => {
    const response = await apiClient.post(
      `/pm-masterdata/delete/maintenance-plans/${id}`,
    );
    return response.data;
  },

  getMaintenancePlanTasks: async (tenantId, planId) => {
    const response = await apiClient.get(
      "/pm-masterdata/maintenance-plan-tasks",
      {
        params: { tenantId, planId },
      },
    );
    return response.data;
  },

  createMaintenancePlanTask: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/maintenance-plan-tasks",
      data,
    );
    return response.data;
  },

  updateMaintenancePlanTask: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/maintenance-plan-tasks/${id}`,
      data,
    );
    return response.data;
  },

  deleteMaintenancePlanTask: async (id) => {
    const response = await apiClient.post(
      `/pm-masterdata/delete/maintenance-plan-tasks/${id}`,
    );
    return response.data;
  },

  // ========== Maintenance Plan Spare Parts (Recommended Parts) ==========
  getMaintenancePlanSpareParts: async (tenantId, maintenancePlanId) => {
    const response = await apiClient.get(
      "/pm-masterdata/maintenance-plan-spare-parts",
      {
        params: { tenantId, maintenancePlanId },
      },
    );
    return response.data;
  },

  createMaintenancePlanSparePart: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/maintenance-plan-spare-parts",
      data,
    );
    return response.data;
  },

  updateMaintenancePlanSparePart: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/maintenance-plan-spare-parts/${id}`,
      data,
    );
    return response.data;
  },

  deleteMaintenancePlanSparePart: async (id) => {
    const response = await apiClient.post(
      `/pm-masterdata/delete/maintenance-plan-spare-parts/${id}`,
    );
    return response.data;
  },

  getPMSchedules: async (tenantId, active) => {
    const response = await apiClient.get("/pm-masterdata/pm-schedules", {
      params: { tenantId, active },
    });
    return response.data;
  },

  getPMSchedule: async (id) => {
    const response = await apiClient.get(`/pm-masterdata/pm-schedules/${id}`);
    return response.data;
  },

  createPMSchedule: async (data) => {
    const response = await apiClient.post("/pm-masterdata/pm-schedules", data);
    return response.data;
  },

  updatePMSchedule: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/pm-schedules/${id}`,
      data,
    );
    return response.data;
  },

  deletePMSchedule: async (id) => {
    const response = await apiClient.post(
      `/pm-masterdata/delete/pm-schedules/${id}`,
    );
    return response.data;
  },

  completePMSchedule: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/pm-schedules/${id}/complete`,
      data,
    );
    return response.data;
  },

  getPMTriggerLogs: async (tenantId, scheduleId) => {
    const response = await apiClient.get("/pm-masterdata/pm-trigger-logs", {
      params: { tenantId, scheduleId },
    });
    return response.data;
  },

  createPMTriggerLog: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/pm-trigger-logs",
      data,
    );
    return response.data;
  },

  updatePMTriggerLog: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/pm-trigger-logs/${id}`,
      data,
    );
    return response.data;
  },

  deletePMTriggerLog: async (id) => {
    const response = await apiClient.post(
      `/pm-masterdata/delete/pm-trigger-logs/${id}`,
    );
    return response.data;
  },

  getMaintenanceWindows: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/maintenance-windows", {
      params: { tenantId },
    });
    return response.data;
  },

  createMaintenanceWindow: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/maintenance-windows",
      data,
    );
    return response.data;
  },

  updateMaintenanceWindow: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/maintenance-windows/${id}`,
      data,
    );
    return response.data;
  },

  deleteMaintenanceWindow: async (id) => {
    const response = await apiClient.post(
      `/pm-masterdata/delete/maintenance-windows/${id}`,
    );
    return response.data;
  },

  getTechnicianSkills: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/technician-skills", {
      params: { tenantId },
    });
    return response.data;
  },

  createTechnicianSkill: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/technician-skills",
      data,
    );
    return response.data;
  },

  updateTechnicianSkill: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/technician-skills/${id}`,
      data,
    );
    return response.data;
  },

  deleteTechnicianSkill: async (id) => {
    const response = await apiClient.post(
      `/pm-masterdata/delete/technician-skills/${id}`,
    );
    return response.data;
  },

  getTechnicianTeams: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/technician-teams", {
      params: { tenantId },
    });
    return response.data;
  },

  createTechnicianTeam: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/technician-teams",
      data,
    );
    return response.data;
  },

  updateTechnicianTeam: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/technician-teams/${id}`,
      data,
    );
    return response.data;
  },

  deleteTechnicianTeam: async (id) => {
    const response = await apiClient.post(
      `/pm-masterdata/delete/technician-teams/${id}`,
    );
    return response.data;
  },

  getTools: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/tools", {
      params: { tenantId },
    });
    return response.data;
  },

  createTool: async (data) => {
    const response = await apiClient.post("/pm-masterdata/tools", data);
    return response.data;
  },

  updateTool: async (id, data) => {
    const response = await apiClient.post(`/pm-masterdata/update/tools/${id}`, data);
    return response.data;
  },

  deleteTool: async (id) => {
    const response = await apiClient.post(`/pm-masterdata/delete/tools/${id}`);
    return response.data;
  },

  getPpeSafety: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/ppe", {
      params: { tenantId },
    });
    return response.data;
  },

  createPpeSafety: async (data) => {
    const response = await apiClient.post("/pm-masterdata/ppe", data);
    return response.data;
  },

  updatePpeSafety: async (id, data) => {
    const response = await apiClient.post(`/pm-masterdata/update/ppe/${id}`, data);
    return response.data;
  },

  deletePpeSafety: async (id) => {
    const response = await apiClient.post(`/pm-masterdata/delete/ppe/${id}`);
    return response.data;
  },

  getSensorTags: async (tenantId, machineId) => {
    const response = await apiClient.get("/pm-masterdata/sensor-tags", {
      params: { tenantId, machineId },
    });
    return response.data;
  },

  createSensorTag: async (data) => {
    const response = await apiClient.post("/pm-masterdata/sensor-tags", data);
    return response.data;
  },

  updateSensorTag: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/sensor-tags/${id}`,
      data,
    );
    return response.data;
  },

  deleteSensorTag: async (id) => {
    const response = await apiClient.post(`/pm-masterdata/delete/sensor-tags/${id}`);
    return response.data;
  },

  getSensorThresholds: async (tenantId, tagId) => {
    const response = await apiClient.get("/pm-masterdata/sensor-thresholds", {
      params: { tenantId, tagId },
    });
    return response.data;
  },

  createSensorThreshold: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/sensor-thresholds",
      data,
    );
    return response.data;
  },

  updateSensorThreshold: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/sensor-thresholds/${id}`,
      data,
    );
    return response.data;
  },

  deleteSensorThreshold: async (id) => {
    const response = await apiClient.post(
      `/pm-masterdata/delete/sensor-thresholds/${id}`,
    );
    return response.data;
  },

  getMeterReadings: async (tenantId, machineId) => {
    const response = await apiClient.get("/pm-masterdata/meter-readings", {
      params: { tenantId, machineId },
    });
    return response.data;
  },

  createMeterReading: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/meter-readings",
      data,
    );
    return response.data;
  },

  getPmHistory: async (tenantId, scheduleId) => {
    const response = await apiClient.get("/pm-masterdata/pm-history", {
      params: { tenantId, scheduleId },
    });
    return response.data;
  },

  createPmHistory: async (data) => {
    const response = await apiClient.post("/pm-masterdata/pm-history", data);
    return response.data;
  },

  updatePmHistory: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/pm-history/${id}`,
      data,
    );
    return response.data;
  },

  getPmCompliance: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/pm-compliance", {
      params: { tenantId },
    });
    return response.data;
  },

  createPmCompliance: async (data) => {
    const response = await apiClient.post("/pm-masterdata/pm-compliance", data);
    return response.data;
  },

  updatePmCompliance: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/pm-compliance/${id}`,
      data,
    );
    return response.data;
  },

  getWorkOrderTypes: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/workorder-types", {
      params: { tenantId },
    });
    return response.data;
  },

  createWorkOrderType: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/workorder-types",
      data,
    );
    return response.data;
  },

  updateWorkOrderType: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/workorder-types/${id}`,
      data,
    );
    return response.data;
  },

  getWorkOrderPriorities: async (tenantId) => {
    const response = await apiClient.get(
      "/pm-masterdata/workorder-priorities",
      { params: { tenantId } },
    );
    return response.data;
  },

  createWorkOrderPriority: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/workorder-priorities",
      data,
    );
    return response.data;
  },

  updateWorkOrderPriority: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/workorder-priorities/${id}`,
      data,
    );
    return response.data;
  },

  getLockoutTagouts: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/lockout-tagout", {
      params: { tenantId },
    });
    return response.data;
  },

  createLockoutTagout: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/lockout-tagout",
      data,
    );
    return response.data;
  },

  updateLockoutTagout: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/lockout-tagout/${id}`,
      data,
    );
    return response.data;
  },

  getSopDocuments: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/sop-documents", {
      params: { tenantId },
    });
    return response.data;
  },

  createSopDocument: async (data) => {
    const response = await apiClient.post("/pm-masterdata/sop-documents", data);
    return response.data;
  },

  updateSopDocument: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/sop-documents/${id}`,
      data,
    );
    return response.data;
  },

  getHolidayCalendar: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/holiday-calendar", {
      params: { tenantId },
    });
    return response.data;
  },

  createHolidayCalendar: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/holiday-calendar",
      data,
    );
    return response.data;
  },

  updateHolidayCalendar: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/holiday-calendar/${id}`,
      data,
    );
    return response.data;
  },

  getVendors: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/vendors", {
      params: { tenantId },
    });
    return response.data;
  },

  createVendor: async (data) => {
    const response = await apiClient.post("/pm-masterdata/vendors", data);
    return response.data;
  },

  updateVendor: async (id, data) => {
    const response = await apiClient.post(`/pm-masterdata/update/vendors/${id}`, data);
    return response.data;
  },

  // ========== Severity Levels ==========
  getSeverityLevels: async (tenantId, status = "") => {
    const params = { tenantId };
    if (status) params.status = status;
    const response = await apiClient.get("/masterdata/severity-levels", { params });
    return response.data;
  },

  // ========== Contractor Agencies (Contractor Master module) ==========
  getContractorAgencies: async (tenantId, status = "") => {
    const response = await apiClient.get("/pm-masterdata/contractor-agencies", {
      params: { tenantId, status },
    });
    return response.data;
  },

  getContractorAgency: async (id) => {
    const response = await apiClient.get(
      `/pm-masterdata/contractor-agencies/${id}`,
    );
    return response.data;
  },

  createContractorAgency: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/contractor-agencies",
      data,
    );
    return response.data;
  },

  updateContractorAgency: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/contractor-agencies/${id}`,
      data,
    );
    return response.data;
  },

  deleteContractorAgency: async (id) => {
    const response = await apiClient.post(
      `/pm-masterdata/delete/contractor-agencies/${id}`,
    );
    return response.data;
  },

  getMaintenanceSla: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/maintenance-sla", {
      params: { tenantId },
    });
    return response.data;
  },

  createMaintenanceSla: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/maintenance-sla",
      data,
    );
    return response.data;
  },

  updateMaintenanceSla: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/maintenance-sla/${id}`,
      data,
    );
    return response.data;
  },

  getNotificationTemplates: async (tenantId) => {
    const response = await apiClient.get(
      "/pm-masterdata/notification-templates",
      { params: { tenantId } },
    );
    return response.data;
  },

  createNotificationTemplate: async (data) => {
    const response = await apiClient.post(
      "/pm-masterdata/notification-templates",
      data,
    );
    return response.data;
  },

  updateNotificationTemplate: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/notification-templates/${id}`,
      data,
    );
    return response.data;
  },

  // ========== Status Master ==========
  getStatuses: async (tenantId, statusType = null, status = "") => {
    const params = { tenantId };
    if (statusType) params.statusType = statusType;
    if (status) params.status = status;
    const response = await apiClient.get("/masterdata/statuses", {
      params,
    });
    return response.data;
  },

  // ========== PM Dashboard (real data) ==========
  getPmDashboard: async (tenantId) => {
    const response = await apiClient.get("/pm-dashboard", {
      params: { tenantId },
    });
    return response.data;
  },

  // ========== PM Standards ==========
  getPMStandards: async (tenantId) => {
    const response = await apiClient.get("/pm-masterdata/pm-standards", {
      params: { tenantId },
    });
    return response.data;
  },

  getPMStandard: async (id) => {
    const response = await apiClient.get(`/pm-masterdata/pm-standards/${id}`);
    return response.data;
  },

  createPMStandard: async (data) => {
    const response = await apiClient.post("/pm-masterdata/pm-standards", data);
    return response.data;
  },

  updatePMStandard: async (id, data) => {
    const response = await apiClient.post(
      `/pm-masterdata/update/pm-standards/${id}`,
      data,
    );
    return response.data;
  },

  deletePMStandard: async (id) => {
    const response = await apiClient.post(
      `/pm-masterdata/delete/pm-standards/${id}`,
    );
    return response.data;
  },

  // ========== Excel Import/Export ==========
  generateTemplate: async (type) => {
    const response = await apiClient.get(`/ExcelImport/template/${type}`, {
      responseType: "blob",
    });
    return response.data;
  },

  importExcel: async (type, file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await apiClient.post(`/ExcelImport/import/${type}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
};

export default masterDataService;
